// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementPresetEmailTemplatesResult = arrayOf(
  objectOf({
    id: string,
    name: string,
    thumbnail_image_url: string,
    is_dnd_template: boolean,
    created_at_timestamp: maybe(number),
  })
);
